import React, { useState, useEffect, Fragment } from "react";
import {
  Row,
  Col,
  CardBody,
  Label,
  Input,
  UncontrolledTooltip
} from "reactstrap";
import { 
  delAddressEmployee,
  putEmployeesAdminUpdate,
  getAddressesEmployee,
  putEmployeesAdminUpdateAddress,
  postEmployeesAdminCreateAddress
} from "../../../helpers/api_rombo_helper";
import i18n from "../../../i18n";
import { useDispatch } from "react-redux";
import { map } from "lodash";
import { useNavigate, Link } from "react-router-dom";
import Places from "../../Google/Places";
import Map from "../../Google/Map";

const Step2 = ({ step, setStep, token, identifier, name, depot, phone, setAddresses, setSelectedAddress, selectedAddress, selectedEmployee, setNewAddresses, newAddresses, infoUser, company, setErrorAlert, setErrorAlertMessage }) => {

  const dispatch = useDispatch();
  const history = useNavigate();
  const [hiddenOne, setHiddenOne] = useState(true);
  const [checkLatLong, setCheckLatLong] = useState(false)
  const [selected, setSelected] = useState({ lng: -99.1446503251791, lat: 19.46416132507601 })
  const [rowsScale, setRowsScale] = useState([]);
  const [titleAdress, setTitleAdress] = useState(null);
  const [nameAddress, setNameAddress] = useState(null);
  
  useEffect(() => {
    onGetAddressEmployee()
  }, [dispatch]);

  const onGetAddressEmployee = () => {
    getAddressesEmployee(token, selectedEmployee.id, { page: 1, size: 50 })
      .then((response) => {
        fillRowsScales(response.items)
      })
      .catch((error) => {
        console.error("Error - getAddressesEmployee - ", error)
      })
  }
  
  const fillRowsScales = (addresses) => {
    let arr = []
    addresses.map((address, key) => {
      if(key == 0){
        setNameAddress(address.name)
        setTitleAdress(i18n.t("TitleAddress", { typeAddress: i18n.t("Predefined"), address: address.address.description }))
        setSelectedAddress({ id: key, newAddress: false, idDB: address.id, name: address.name, latLon: false, addresssMap: true, description: address.address.description, location: address.address.location })
        setSelected({ lng: address.address.location.lon, lat: address.address.location.lat })
      }else{
        arr.push({ id: key, idDB: address.id, newAddress: false, editRow: true, name: address.name, latLon: false, addresssMap: true, address: { description: address.address.description, location: address.address.location } })
      }
    })
    setRowsScale([...arr])
  }

  const onClickLatLong = () => {
    setCheckLatLong(!checkLatLong);
  };

  const onBackStep = () => {
    setStep(step - 1);
  };

  const handleAddRowScale = () => {
    let id = 0
    let onRowsScale = rowsScale
    id = (rowsScale.length != 0) && rowsScale[rowsScale.length-1].id + 1
    onRowsScale.push({ id: id, newAddress: true, latLon: false, editRow: false, addresssMap: false,
                          address: { location: { lon: -99.1446503251791, lat: 19.46416132507601 } } });
    onRowsScale.sort((a, b) => (a.id > b.id) ? 1 : -1)
    setRowsScale([...onRowsScale]);
  }

  const handleRemoveRowScale = (id) => {
    if(rowsScale.length == 1)
      return;

    const updatedRows = rowsScale.filter((row) => row.id !== id);
    setRowsScale(updatedRows);
  }

  const onClickEdit = (address) => {
    let arr = rowsScale.map((opt) => ({
      ...opt,
      editRow: opt.id !== address.id,
      addresssMap: opt.id !== address.id
    }));
  
    let fAddress = arr.find((opt) => opt.id === address.id);
    if (fAddress) {
      fAddress.editRow = false;
      fAddress.addresssMap = false;
      setHiddenOne(true);
      setRowsScale([...arr]);
    }
  };  

  const onDelAddressEmployee = (address) => {
    delAddressEmployee(token, selectedEmployee.id, address.idDB)
      .then((response) => {
        const updatedRows = rowsScale.filter((row) => address.idDB !== row.idDB);
        setRowsScale(updatedRows);
      })
      .catch((error) => {
        console.error("Error - delAddressEmployee - ", error);
      });
  };
  
  const onClickDelete = (address) => {
    onDelAddressEmployee(address);
  };  
  
  const onClickLatLongAddreses = (e, formRow) => {
    let arr = rowsScale;
    let address = arr
      .filter(function (opt) {
        return opt.id === formRow.id;
      })
      .shift();
  
    if (address) {
      arr.splice(arr.indexOf(address), 1);
      address.latLon = e.target && e.target.checked ? true : false;
      arr.push(address);
      arr.sort((a, b) => (a.id > b.id ? 1 : -1));
      setRowsScale([...arr]);
    }
  };  

  const onChangeAddScalesRow = (formRow, valInput, type) => {
    let rowScale = null
    let arrScales = rowsScale
    let address = type == "address" ? valInput.target.value : ""
    let lon = type == "latitude" ? valInput.target.value : ""
    let lat = type == "longitude" ? valInput.target.value : ""
    let addressName = type == "addressName" ? valInput.target.value : ""
    if(arrScales.length == 0){
      rowScale = { id: formRow.id, idDB: formRow.idDB, name: addressName, editRow: true, latLon: false, addresssMap: true, address: { description: address, location: { lat, lon } } }
      arrScales.push(rowScale)
    }else{
      rowScale = arrScales.filter(function(opt) {
        return opt.id === formRow.id
      }).shift();
      if(rowScale){
        arrScales.splice(arrScales.indexOf(rowScale), 1)
        rowScale.address.description = type == "address" ? valInput.target.value : rowScale.address.description
        rowScale.name = type == "addressName" ? valInput.target.value : rowScale.name
        rowScale.address.location.lat = type == "latitude" ? parseFloat(valInput.target.value) : rowScale.address.location.lat
        rowScale.address.location.lon = type == "longitude" ? parseFloat(valInput.target.value) : rowScale.address.location.lon
        arrScales.push(rowScale)
      }else{
        rowScale = { id: formRow.id, name: addressName, editRow: true, latLon: false, addresssMap: true, address: { description: address, location: { lat, lon } } }
        arrScales.push(rowScale)
      }
    }
    setRowsScale([...arrScales])
  }

  const onEditEmployee = () => {
    let addresses = []
    let arr2 = []
    selectedAddress.idDB ? addresses.push({ id: selectedAddress.idDB, name: nameAddress, address: selectedAddress }) :
                            arr2.push({ name: nameAddress, address: selectedAddress })
    if(selectedAddress.description){
      rowsScale.map((address) => {
        if(address.idDB){
          address.name ? addresses.push({ id: address.idDB, name: address.name, address: address.address }) : null
        }else{
          arr2.push({ name: address.name, address: address.address })
        }
      })
      setAddresses([...addresses])
      setNewAddresses([...arr2])
      let body = {
        identifier: identifier,
        name: name,
        depot: depot,
        // email: email,
        phone: phone,
        // company_name: company,
        travel_limit: 0,
        monthly_amount_limit: 0,
        job_position: "Default",
        cost_center_id: null,
        latitude: selectedAddress.location.lat,
        longitude: selectedAddress.location.lon,
        policies: {
          parking: false,
          toll: false
        }
      }
      if(infoUser.is_staff) body.company_id = company.value
      putEmployeesAdminUpdate(token, selectedEmployee.id, body)
        .then((response) => {
          localStorage.setItem("notify", "true")
          localStorage.setItem("headerText", i18n.t("UpdatedEmployee"))
          localStorage.setItem("bodyText", i18n.t("SuccessUpdatedEmployee"))
          if(arr2.length != 0){
            postEmployeesAdminCreateAddress(token, response.id, { addresses: arr2})
              // .then((response) => { console.log("Response - postEmployeesAdminCreateAddress - ", response) })
              .then((response) => { "Success" })
              .catch((error) => { console.error("Error - postEmployeesAdminCreateAddress - ", error) })
          }
          if(addresses.length != 0){
            addresses.map((address) => {
              putEmployeesAdminUpdateAddress(token, selectedEmployee.id, address.id, address)
                // .then((response) => { console.log("Response - putEmployeesAdminUpdateAddress - ", response) })
                .then((response) => { "Success" })
                .catch((error) => { console.error("Error - putEmployeesAdminUpdateAddress - ", error) })
            })
          }
          history("/employees")
        })
        .catch((error) => {
          console.error("Error - putEmployeesAdminUpdate - ", error);
          setErrorAlertMessage((error.response?.data?.detail || error.message))
          setErrorAlert(true)
        })
    }else{
      setErrorAlert(true)
      setErrorAlertMessage(i18n.t("PleaseFillDefaultAddress"))
    }
  }

  return (
    <Fragment>
      <CardBody>
        <Row>
          <Col xs={12} xxl={12} xl={12} className="pb-3">
            <h6 className="employees-form-title">{i18n.t("Addresses")}</h6>
            <span className="employees-form-text">{i18n.t("DescAddresses")}</span>
          </Col>
          <Col xs={12} xxl={6} xl={6} className="row h-100">
            <Col xs={12} xxl={6} xl={6} className="">
              <Label className="employees-form-subtitle" htmlFor="nameInput">{i18n.t("AddressName")}</Label>  
              <Input
                type="text"
                name="name"
                className="form-control"
                id="nameInput"
                onChange={(e) => setNameAddress(e.target.value)}
                defaultValue={nameAddress}
                placeholder={i18n.t("EnterAddressName")}
              />
            </Col>
            <Col xs={12} xxl={6} xl={6} className="">
              <Label className="employees-form-subtitle" htmlFor="defaultAddressInput">{i18n.t("DefaultAddress")}</Label>
              <Places 
                selected={selected}
                selectedAddress={selectedAddress}
                setSelectedAddress={setSelectedAddress}
                typeAddress={'predefined'}
                setSelected={setSelected}
                setTitleAdress={setTitleAdress}
                disabled={checkLatLong}
                id={"defaultAddress"}
                editAddress={true}
                hiddenOne={hiddenOne}
                setRowsScale={setRowsScale}
                rowsScale={rowsScale}
                setHiddenOne={setHiddenOne}
                placeholder={i18n.t("WriteDefaultaddress")}
              />
            </Col>
            <div className="employees-lat-lng-container">
              <input
                className="employees-form-checkbox"
                type="checkbox"
                id="addUseLatLong"
                name="addUseLatLong"
                onClick={onClickLatLong}
              />
              <label
                lassName="employees-form-checkbox-label"
                htmlFor="addUseLatLong"
              >
                {i18n.t("AddUseLatLong")}
              </label>
            </div>
            {checkLatLong &&
              <Col xxl={12} md={12} xs={12} className="row">                  
                <Col xxl={6} md={6} xs={12}>                  
                  <Label className="latitude" htmlFor="latitudeInput">{i18n.t("Latitude")}</Label>
                  <Input
                    type="number"
                    name="latitude"
                    className="form-control"
                    id="latitudeInput"
                    placeholder={i18n.t("WriteLatitude")}
                  />
                  <p/>
                </Col>
                <Col xxl={6} md={6} xs={12}>               
                  <Label className="longitude" htmlFor="longitudeInput">{i18n.t("Longitude")}</Label>
                  <Input
                    type="number"
                    name="longitude"
                    className="form-control"
                    id="longitudeInput"
                    placeholder={i18n.t("WriteLongitude")}
                  />
                </Col>
              </Col>
            }
            <Col xs={12} xxl={12} xl={12} className="pb-3">
              <div className="request-separator"></div>
              <div className="inner-repeater mb-4">
                <h6 className="employees-form-title">{i18n.t("TitleAddresses")}</h6>
                <span className="employees-form-text">{i18n.t("DescTitleAddresses")}</span>
                <p/>
                <table style={{ width: "100%" }}>
                  <tbody>
                    {(rowsScale).map((formRow, key) => (
                      <tr key={key}>
                        <td>
                          <Row>
                            <Col xs={12} xxl={6} xl={6} className="">
                              <Label className="visually" htmlFor="scaleAddressInput">
                                {i18n.t("AdditionalAddressName") + " " + (formRow.id + 1)}
                              </Label>
                              <Input 
                                type="text"
                                name="addresses[][name]"
                                className="form-control"
                                disabled={formRow.editRow && formRow.idDB}
                                value={formRow.name}
                                id={`name-${key}`}
                                placeholder={i18n.t("AddressName")}
                                onChange={(e) => onChangeAddScalesRow(formRow, e, "addressName")}
                              />
                            </Col>
                            <Col xs={12} xxl={6} xl={6} className="">
                              <div className="col-sm-auto mb-2">
                                <Label className="visually" htmlFor="scaleAddressInput">
                                  {i18n.t("AdditionalAddress") + " " + (formRow.id + 1)}
                                </Label>
                                <Places 
                                  selected={selected}
                                  selectedAddress={null}
                                  setSelectedAddress={null}
                                  typeAddress={'array'}
                                  setSelected={null}
                                  setTitleAdress={setTitleAdress}
                                  disabled={formRow.editRow && formRow.idDB}
                                  id={`address-${key}`}
                                  setRowsScale={setRowsScale}
                                  rowsScale={rowsScale}
                                  addressRow={formRow}
                                  hiddenOne={hiddenOne}
                                  setHiddenOne={setHiddenOne}
                                  placeholder={i18n.t("Address")}
                                />
                              </div>
                            </Col>
                            {/*<Col xxl={2} md={2} xs={2}>
                              {!formRow.idDB && (
                                <div className="d-grid mt-4">
                                  <Link
                                    className="text-center"
                                    onClick={() => handleRemoveRowScale(formRow.id)}>
                                    <i className="fa fa-trash text-danger"></i>
                                  </Link>
                                </div>
                              )}
                            </Col>*/}
                            <Col xxl={12} md={12} xs={12}>
                              <div className="employees-lat-lng-container">
                                <input
                                  className="employees-form-checkbox"
                                  type="checkbox"
                                  id={`addUseLatLong-${key}`}
                                  name={`addUseLatLong-${key}`}
                                  onClick={(e) => onClickLatLongAddreses(e, formRow)}
                                />
                                <label
                                  className="employees-form-checkbox-label"
                                  htmlFor={`addUseLatLong-${key}`}
                                >
                                  {i18n.t("AddUseLatLong")}
                                </label>
                              </div>
                              {formRow.latLon &&
                                <Col xxl={12} md={12} xs={12} className="row">                  
                                  <Col xxl={6} md={6} xs={12}>                  
                                    <Label className="latitude" htmlFor="latitudeInput">{i18n.t("Latitude")}</Label>
                                    <Input
                                      type="number"
                                      name="latitude"
                                      defaultValue={formRow.address.location.lat}
                                      onChange={(e) => onChangeAddScalesRow(formRow, e, "latitude")}
                                      className="form-control"
                                      id="latitudeInput"
                                      placeholder={i18n.t("Latitude")}
                                    />
                                  </Col>
                                  <Col xxl={6} md={6} xs={12}>                  
                                    <Label className="longitude" htmlFor="longitudeInput">{i18n.t("Longitude")}</Label>
                                    <Input
                                      type="number"
                                      name="longitude"
                                      defaultValue={formRow.address.location.lon}
                                      onChange={(e) => onChangeAddScalesRow(formRow, e, "longitude")}
                                      className="form-control"
                                      id="longitudeInput"
                                      placeholder={i18n.t("Longitude")}
                                    />
                                  </Col>
                                </Col>
                              }
                            </Col>
                            <Col xs={12} xxl={12} xl={12} className="pb-3">
                              {/*<h6>{`${i18n.t("AditionalAddresses")} (${rowsScale.length}/4)`}</h6>*/}
                              {
                                map(rowsScale, (item, key) => {
                                  if(!item.idDB) return 
                                  return (
                                    <div className="col-12">
                                      <div className="d-flex gap-3">
                                        <h6 className="fs-12 p-0 m-0">
                                          {item.name}
                                         <a
                                            className="text-success"
                                            onClick={() => onClickEdit(item)}>
                                            <i className="mdi mdi-pencil font-size-18 button-margin-minleft" id="edittooltip" />
                                            <UncontrolledTooltip placement="top" target="edittooltip">
                                              {i18n.t("Edit")}
                                            </UncontrolledTooltip>
                                          </a>
                                          <a
                                            className="text-danger"
                                            onClick={() => onClickDelete(item)}>
                                            <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                                            <UncontrolledTooltip placement="top" target="deletetooltip">
                                              {i18n.t("Delete")}
                                            </UncontrolledTooltip>
                                          </a>
                                        </h6>
                                      </div>
                                     <span className="fs-10">{`${item.name} - ${item.address.description}`}</span>
                                    </div>
                                  )
                                })
                              }
                            </Col>
                            <div className="request-separator"></div>
                          </Row>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {rowsScale.length < 1 && 
                  <a
                    className="text-dark"
                    onClick={() => {
                      handleAddRowScale();
                    }}
                  >
                    <i className="bx bx-plus" />
                      {i18n.t("AddAddress")}
                  </a>
                }
              </div>
            </Col>
          </Col>
          <Col xs={12} xxl={6} xl={6} className="row h-100">
            <Col xs={12} xxl={12} xl={12} className="z-index-1 row h-100 pb-5">
              {!rowsScale.some((row) => !row.editRow) && (
                <Map
                  nameTitle={titleAdress}
                  selectedAddress={selectedAddress}
                  setSelectedAddress={setSelectedAddress}
                  selected={selected}
                  setSelected={setSelected}
                  hiddenOne={hiddenOne}
                  setHiddenOne={setHiddenOne}
                  addressRow={null}
                  type={'one'}
                  id={"defaultAddress"}
                />
              )}
              {rowsScale.map((address, key) => (
                !address.editRow && (
                  <Map
                    key={key}
                    nameTitle={i18n.t("TitleAddress", { typeAddress: `${i18n.t("Additional")} ${address.id + 1}`, address: address.address.description })}
                    selected={{ lng: address.address.location.lon, lat: address.address.location.lat }}
                    setSelected={null}
                    hiddenArray={address.addresssMap}
                    setRowsScale={setRowsScale}
                    rowsScale={rowsScale}
                    addressRow={address}
                    hiddenOne={false}
                    type={'array'}
                    id={address.id}
                  />
                )
              ))}
            </Col>
          </Col>
          <Col xxl={12} md={12} xs={12} className="d-flex">
            <button onClick={() => onEditEmployee()} className="btn btn-request fs-11">{i18n.t("Save")}</button>
            <button onClick={() => onBackStep()} className="btn btn-go-back border fs-11 mx-2">{i18n.t("Back")}</button>
          </Col>
        </Row>
      </CardBody>
    </Fragment>
  )
}

export default Step2;
